'use strict';

module.exports = function implode(key, glue) {
  if (glue === undefined) {
    return this.items.join(key);
  }

  return new this.constructor(this.items).pluck(key).all().join(glue);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/implode.js
// module id = 1233
// module chunks = 2